import Select from 'react-select'
import { Controller } from 'react-hook-form';
import { InputError, LightTooltip } from '../utils';
import {useState} from "react";

export const SelectOption = ({
    lable_text, 
    optionList, 
    name,
     hasError,
    placeholder, 
    errorMessage, 
    control, 
    disbale, 
    tooltip_title,
    ...props
}) => {

    const [firstTime, setFirstTime] = useState(true)

    return (

        <div className='row justify-content-center mt-2'>
            <div className='col-12 col-md-5'>

                <label className="form-label text-form-title"  
                >{lable_text}</label>

                {/* <LightTooltip tooltip_title={tooltip_title} /> */}

                <Controller
                    name={name}
                    control={control}
                    rules={{ required: errorMessage }}
                    render={({ field , fieldState: {invalid, error}}) => (

                        <>
                            <Select
                                {...field}

                                options={optionList}
                                placeholder={placeholder}
                                isDisabled={disbale}
                                onChange={ (e) => {
                                    if(!disbale) {
                                        field.onChange(e)
                                        setFirstTime(false)
                                    }

                                }}
                                clearable={false}
                                styles={{
                                control: (provided, state) => ({
                                    ...provided,
                                    borderRadius: 10,
                                    borderColor: state.isFocused ?
                                        '#044448' : error || (firstTime && hasError) == 'error' ?
                                            "red" : (firstTime && hasError) == 'correct' ?
                                                '#54ac12' : provided.borderColor,
                                    fontFamily: "IRANYekanX"
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#044448' : provided.backgroundColor,
                                    color: state.isFocused ? 'white' : provided.color,
                                    borderRadius: 5,
                                    fontFamily: "IRANYekanX",
                                }),
                                placeholder: (provided, state) => ({
                                    ...provided,
                                    fontSize: '1rem', // Set the font size for the placeholder
                                    fontWeight: '400'
                                }),
                                menuList: (base) => ({
                                    ...base,
                                    "::-webkit-scrollbar": {
                                    width: "6px",
                                    height: "0px",

                                    },
                                    "::-webkit-scrollbar-track": {
                                    background: "#f1f1f1"
                                    },
                                    "::-webkit-scrollbar-thumb": {
                                    background: "#044448",
                                    borderRadius: "15px"
                                    },
                                    "::-webkit-scrollbar-thumb:hover": {
                                    background: "#555"
                                    }
                                })
                                }}
                            /> 
                            {error && ( <InputError message={error.message} show={true}/> )}
                        </>
                        
                    )}
                />

                

            </div>
        </div>
    )
} 